import { render } from "./privacy-modal.vue?vue&type=template&id=4225a193"
import script from "./privacy-modal.vue?vue&type=script&lang=ts"
export * from "./privacy-modal.vue?vue&type=script&lang=ts"

import "./privacy-modal.vue?vue&type=style&index=0&id=4225a193&lang=scss"
script.render = render

export default script